<template>
  <div class="activity-detail-page">
    <!-- 顶部导航 -->
    <div class="top-nav">
      <div class="back-btn" @click="$router.push('/activity/activityList')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </div>
      <h1 class="title">活动详情</h1>
      <div class="share-btn"></div>
    </div>

    <!-- 活动头图 -->
    <div class="banner">
      <img :src="activity.coverFileId" alt=""/>
      <div class="corner-tag status">{{ activity.statusName }}</div>
    </div>

    <!-- 活动基本信息 -->
    <div class="info-section">
      <h2 class="activity-title">{{ activity.name }}</h2>
      <div class="tags">
        <span class="tag category">{{ activity.activityType || '综合活动' }}</span>
        <span class="tag free">{{ activity.free ? '免费' : '收费' }}</span>
        <span class="tag limit">限额{{ activity.limitNum || 0 }}人</span>
      </div>

      <div class="info-item">
        <div class="info-icon time">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ff7d00" stroke-width="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
        </div>
        <div class="info-content">
          <div class="label">活动时间</div>
          <div class="value">{{ activity.time }}</div>
        </div>
      </div>

      <div class="info-item">
        <div class="info-icon location">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1677ff" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
        </div>
        <div class="info-content">
          <div class="label">活动地点</div>
          <div class="value">{{ activity.addressName }}</div>
          <div class="sub-value">{{ activity.detailAddress }}</div>
        </div>
      </div>

      <div class="info-item">
        <div class="info-icon people">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0fb864" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        </div>
        <div class="info-content">
          <div class="label">已报名人数</div>
          <div class="progress-wrap">
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: progressPercent + '%' }"></div>
            </div>
            <div class="progress-text">
              <span class="current">{{ activity.presentNum }}</span>
              <span class="total">限额{{ activity.limitNum || 0 }}人</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 活动详情 -->
    <div class="detail-section">
      <h3 class="section-title">活动详情</h3>
      <div class="rich-content" v-html="activity.content"></div>
    </div>

    <!-- 底部报名栏 -->
    <div class="bottom-bar">
      <div class="price-info">
        <div class="label">报名费用</div>
        <div class="price">{{ activity.free ? '免费' : '收费' }}</div>
      </div>
      <button class="sign-btn" :class="{ disabled: !canRegister || submitting }" :disabled="!canRegister || submitting"
              @click="openSignModal">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="8.5" cy="7" r="4"></circle>
          <line x1="20" y1="8" x2="20" y2="14"></line>
          <line x1="23" y1="11" x2="17" y2="11"></line>
        </svg>
        {{ signButtonText }}
      </button>
    </div>

    <!-- 报名弹窗 -->
    <transition name="slide-up">
      <div v-if="showSignModal" class="modal-mask" @click="showSignModal = false">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h2 class="modal-title">活动报名</h2>
            <div class="close-btn" @click="showSignModal = false">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </div>
          </div>

          <div class="activity-info">
            <img :src="activity.coverFileId" alt="" class="activity-img"/>
            <div class="info-text">
              <p class="activity-name">{{ activity.name }}</p>
              <p class="activity-time">{{ activity.time }}</p>
            </div>
          </div>

          <div class="form-section">
            <div class="form-item">
              <label class="label">联系人 <span class="red">*</span></label>
              <div class="input-wrap">
                <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                <input v-model="formData.contactName" type="text" placeholder="请输入联系人姓名"/>
              </div>
            </div>

            <div class="form-item">
              <label class="label">联系电话 <span class="red">*</span></label>
              <div class="input-wrap">
                <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <input v-model="formData.contactTell" type="tel" placeholder="请输入联系电话"/>
              </div>
            </div>

            <div class="form-item">
              <label class="label">公司名称/所在社区<span class="red">*</span></label>
              <div class="input-wrap">
                <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
                  <path d="M3 21h18"></path>
                  <path d="M5 21V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v16"></path>
                  <path d="M16 8h1a2 2 0 0 1 2 2v11"></path>
                  <path d="M9 7h3"></path>
                  <path d="M9 11h3"></path>
                  <path d="M9 15h3"></path>
                </svg>
                <input v-model="formData.companyName" type="text" placeholder="请输入公司名称/所在社区"/>
              </div>
            </div>

            <div class="form-item">
              <label class="label">职位/在职或退休<span class="red">*</span></label>
              <div class="input-wrap">
                <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
                  <rect x="3" y="7" width="18" height="13" rx="2"></rect>
                  <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  <path d="M3 13h18"></path>
                  <path d="M10 12h4"></path>
                </svg>
                <input v-model="formData.job" type="text" placeholder="请输入职位/在职或退休"/>
              </div>
            </div>

            <div class="form-item">
              <label class="label">报名人数</label>
              <div class="num-wrap">
                <button class="num-btn" @click="formData.presentNum > 1 ? formData.presentNum-- : null">-</button>
                <span class="num-text">{{ formData.presentNum }}</span>
                <button class="num-btn" @click="formData.presentNum++">+</button>
              </div>
            </div>
          </div>

          <button class="submit-btn" @click="handleSubmit">确认报名</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ActivityDetail',
  data() {
    return {
      isLogin:false,
      showSignModal: false,
      formData: {
        tournamentId: 0,
        contactName: '',
        contactTell: '',
        companyName: '',
        job: '',
        presentNum: 1
      },
      activity: {
        img: 'https://picsum.photos/400/200?random=1',
        statusName: '',
        name: '',
        activityType: '',
        free: true,
        limitNum: 0,
        presentNum: 0,
        time: '',
        addressName: '',
        detailAddress: '',
        content: ''
      },
      submitting: false
    }
  },
  computed: {
    progressPercent() {
      const total = this.activity.limitNum || 0
      if (total <= 0) return 0
      return Math.min((this.activity.presentNum / total) * 100, 100)
    },
    canRegister() {
      if (this.activity.registrationStatus == 1 || this.activity.registrationStatus == 2) return false
      if (this.activity.status == 3) return false
      if (this.activity.limitNum && this.activity.presentNum >= this.activity.limitNum) return false
      return true
    },
    signButtonText() {
      if (this.activity.registrationStatus == 1) return '审批中'
      if (this.activity.registrationStatus == 2) return '已报名'
      if (this.activity.status == 3) return '活动已结束'
      if (this.activity.limitNum && this.activity.presentNum >= this.activity.limitNum) return '名额已满'
      return this.submitting ? '提交中...' : '立即报名'
    }
  },
  mounted() {
    this.getDetail()
    if(JSON.parse(sessionStorage.getItem('userInfo')).nickname){
      this.isLogin = true
    }else{
      this.isLogin = false
    }
  },
  methods: {
    async getDetail() {
      const id = this.$route.params.id
      this.formData.tournamentId = id
      if (!id) return

      try {
        const res = await this.$ajax.get('/api/tournament/detail', {
          params: {id}
        })

        if (res.data.code === 200) {
          const data = res.data.data
          this.activity = {
            ...this.activity,
            ...data,
            statusName: data.statusName,
            time: `${this.formatTime(data.startTime)} 至 ${this.formatTime(data.endTime)}`
          }
        }
      } catch (err) {
        console.error('获取详情失败', err)
      }
    },
    formatTime(time) {
      if (!time) return ''
      return time.replace('T', ' ')
    },
    openSignModal() {
      if(!this.isLogin){
        let id = this.formData.tournamentId
        this.$router.push(`/blank/${id}`)
        return
      }
      if (!this.canRegister) {
        this.$toast.error(this.signButtonText)
        return
      }
      this.showSignModal = true
    },
    handleSubmit() {
      if (!this.canRegister) {
        this.$toast.error(this.signButtonText)
        this.showSignModal = false
        return
      }
      if (this.submitting) return
      if (!this.formData.contactName.trim()) {
        this.$toast.error('请输入联系人姓名')
        return
      }
      if (!/^1\d{10}$/.test(this.formData.contactTell)) {
        this.$toast.error('请输入正确手机号')
        return
      }
      if (!this.formData.companyName.trim()) {
        this.$toast.error('请输入公司名称')
        return
      }
      if (!this.formData.job.trim()) {
        this.$toast.error('请输入职位')
        return
      }
      this.submitting = true
      this.$ajax.post('/api/tournament/register', this.formData).then((res) => {
        if (res.data.code == 200) {
          this.$toast.success('报名已提交，审核中')
          this.showSignModal = false
          this.getDetail()
        }
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>

<style scoped>
/* 你的原有样式全部保留，我没有改动任何样式 */
.activity-detail-page {
  background: #fff;
  min-height: 100vh;
  padding-bottom: 80px;
}

.top-nav {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
}

.back-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  flex: 1;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.share-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner {
  position: relative;
  height: 200px;
}

.banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.corner-tag {
  position: absolute;
  top: 12px;
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  color: #fff;
}

.corner-tag.status {
  right: 0;
  background: #ff7d00;
}

.info-section {
  padding: 20px;
}

.activity-title {
  font-size: 18px;
  font-weight: bold;
  color: #1a1a1a;
  margin: 0 0 12px;
}

.tags {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.tag {
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 12px;
}

.tag.category {
  background: #fff2e8;
  color: #ff7d00;
}

.tag.free {
  background: #e6ffed;
  color: #0fb864;
}

.tag.limit {
  background: #e6f7ff;
  color: #1677ff;
}

.info-item {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.info-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.info-icon.time {
  background: #fff2e8;
}

.info-icon.location {
  background: #e6f7ff;
}

.info-icon.people {
  background: #e6ffed;
}

.info-content {
  flex: 1;
}

.label {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
}

.value {
  font-size: 14px;
  color: #1a1a1a;
  font-weight: 500;
}

.sub-value {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.progress-wrap {
  margin-top: 4px;
}

.progress-bar {
  height: 8px;
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #ff7d00, #ffb020);
  border-radius: 4px;
}

.progress-text {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 4px;
}

.progress-text .current {
  color: #ff7d00;
  font-weight: bold;
}

.progress-text .total {
  color: #999;
}

.detail-section {
  padding: 0 20px 20px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.section-title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 18px;
  background: #ff7d00;
  margin-right: 8px;
}

.desc-text {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  margin-bottom: 20px;
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 9;
}

.price-info {
  margin-right: 16px;
}

.price-info .label {
  font-size: 12px;
  color: #999;
}

.price {
  font-size: 16px;
  font-weight: bold;
  color: #ff7d00;
}

.sign-btn {
  flex: 1;
  background: #ff7d00;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.sign-btn.disabled {
  background: #c9cdd4;
  box-shadow: none;
}

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  z-index: 100;
}

.modal-content {
  width: 100%;
  background: #fff;
  border-radius: 16px 16px 0 0;
  padding: 20px;
  box-sizing: border-box;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.modal-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.close-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.activity-info {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.activity-img {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
}

.info-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.activity-name {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.activity-time {
  font-size: 12px;
  color: #666;
  margin: 0;
}

.form-section {
  margin-bottom: 20px;
}

.form-item {
  margin-bottom: 16px;
}

.label {
  font-size: 13px;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

.red {
  color: #ff4d4f;
}

.input-wrap {
  display: flex;
  align-items: center;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 0 12px;
  height: 44px;
}

.input-wrap .icon {
  margin-right: 8px;
}

.input-wrap input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 13px;
}

.num-wrap {
  display: flex;
  align-items: center;
  border: 1px solid #eee;
  border-radius: 8px;
  width: 120px;
  height: 44px;
}

.num-btn {
  width: 40px;
  height: 100%;
  border: none;
  background: #f5f5f5;
  font-size: 18px;
  color: #333;
}

.num-text {
  flex: 1;
  text-align: center;
  font-size: 13px;
}

.submit-btn {
  width: 100%;
  height: 48px;
  background: #ff7d00;
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
}

.slide-up-enter-active {
  transition: transform 0.3s ease-out;
}

.slide-up-leave-active {
  transition: transform 0.2s ease-in;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}

/* 富文本核心样式：自适应图片、统一文字排版 */
.rich-content {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
}

.rich-content >>> p {
  margin: 0 0 12px 0;
}

/* 富文本图片自适应，防止溢出屏幕 */
.rich-content >>> img {
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 10px auto;
  border-radius: 8px;
}

.rich-content >>> h1,
.rich-content >>> h2,
.rich-content >>> h3,
.rich-content >>> h4 {
  margin: 16px 0 8px;
  font-weight: 600;
}

.rich-content >>> ul,
.rich-content >>> ol {
  padding-left: 20px;
  margin: 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/activity/info.vue